import Enum from "../../../enums/Enum";

const DirectBillingResubmissionTypeEnum = new Enum({
    INTERNAL_COMPLAINT: {name: "Internal Complaint"},
    CORRECTION: {name: "Correction"}
});

export default DirectBillingResubmissionTypeEnum;
